package com.anjuros.website.redesign.sections.trades

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdClosingCard
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText

/** "Don't see your trade?" call to action at the end of the page. */
@Composable
fun TradesClosingSection() {
    RdClosingCard(
        RdText.TRADES_CLOSE_EYEBROW, RdText.TRADES_CLOSE_TITLE, RdText.TRADES_CLOSE_LEDE,
        secondaryText = RdText.CTA_SEE_ALL_DESIGNS, secondaryPath = RdRoute.DESIGNS,
    )
}
